<!-- Compact -->
<compact-acc-layout></compact-acc-layout>